export function whenDefined<T, U>(
  value: T | undefined,
  mutation: (value: T) => U
): U | undefined {
  return value ? mutation(value) : undefined;
}

export const isDev = process.env.NODE_ENV === 'development';
